<mat-card class="p-4 shadow-lg mb-1">
  <h3 class="mb-3 text-lg font-semibold text-(--pg-brand-red)">{{ title() }}</h3>

  @if (history().length === 0) {
    <p class="text-sm">{{ emptyLabel() }}</p>
  } @else {
    <div class="grid gap-3 min-w-0">
      @for (item of history(); track item.id) {
        <div class="min-w-0 rounded-2xl border p-3">
          <p class="text-sm font-semibold text-(--pg-brand-blue)">
            {{ item.description || (item.action + ' at ' + (item.changedDate | serverTime | date: 'd MMM y, HH:mm')) }}
          </p>
          <p class="text-sm">
            {{ item.action }} · {{ item.changedDate | serverTime | date: 'd MMM y, HH:mm' }} · Changed by: {{ item.changedBy ?? 'Unknown' }}
          </p>
          @if (item.changedFields) {
            <p class="break-words text-sm">Fields changed: {{ item.changedFields }}</p>
          }
        </div>
      }
    </div>
  }
</mat-card>
